"use client";

import type { MobileHighlightsBlock } from "@mw/shared/payload-types";

import dynamic from "next/dynamic";

const BlockMobileHighlights = dynamic(() => import("./BlockMobileHighlights").then(mod => mod.BlockMobileHighlights));

export const BlockMobileHighlightsWrapper = (props: MobileHighlightsBlock) => {
  return <BlockMobileHighlights {...props} />;
};
